module.exports = __webpack_public_path__ + "static/img/int7.85a8aed5.jpg";